import request from '@/utils/request'

export function index(params) {
    return request({
        url: 'visitors/guest_phone_numbers',
        method: 'get',
        params: params
    })
}

export function inventory(params) {
    return request({
        url: 'visitors/guest_phone_number/inventory',
        method: 'get',
        params: params
    })
}

export function show(id) {
    return request({
        url: `/visitors/guest_phone_numbers/${id}`,
        method: 'get'
    })
}

export function store(data) {
    return request({
        url: `visitors/guest_phone_numbers`,
        method: 'post',
        data
    })
}

export function update(data) {
    return request({
        url: `visitors/guest_phone_numbers/${data.id}`,
        method: 'put',
        data
    })
}

export function destroy(data) {
    return request({
        url: `visitors/guest_phone_numbers/${data.id}`,
        method: 'delete',
    })
}
